export default "__VITE_ASSET__DTaTTNso__"